import * as reportLimits from './reportLimits';

ReportDialogController.$inject = ['downloadService', 'reportService', 'ObjectCache'];
function ReportDialogController(downloadService, reportService, ObjectCache) {

    this.$onInit = function () {
        const filter = this._resolve.filter;

        if (filter.persons == null || filter.persons.length === 0) {
            this.error = "Inga personer valda";
        } else if (filter.persons.length > reportLimits.MaxPersonIds) {
            this.error = "För många personer valda (max " + reportLimits.MaxPersonIds + ")";
        } else {
            filter.persons = filter.persons.map(x => x.Id).filter(x => x != null);
            this.selection = filter.persons.length + ((filter.persons.length === 1) ? " person" : " personer");
        }

        reportService.getPersonReports().then(list => {
            this.reports = list;
            this.report = this.reports[0];
            this.reportChanged();
        }).catch(err => void (this.error = err));

        ObjectCache.allWageTypes().then(data => void (this.wageTypes = data));
    };

    this.reportChanged = function () {
        this.enable = this.report.params;
        this.args = reportService.getDefaultArguments(this.report);
        this.args.Query.PersonIds = this._resolve.filter.persons;
    };

    this.canSave = function () {
        return this.form && this.form.$valid && !this.isSaving && this._resolve.filter.persons.length > 0 && this._resolve.filter.persons.length <= reportLimits.MaxPersonIds;
    };

    this.submit = function submit() {

        if (!this.canSave()) return;

        this.isSaving = true;
        this.error = null;

        reportService
            .generate(this.report.Id, this.args)
            .finally(() => this.isSaving = false)
            .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename))
            .catch(err => void (this.error = err));
    };

    this.close = function () {
        this._close({ $value: 'done' });
    };
}

angular.module("tromanWeb").component("ergoReportDialog", {
    template: require('./reportDialog.html'),
    bindings: {
        _close: '&close',
        _dismiss: '&dismiss',
        _resolve: '<resolve',
        _modal: '<modalInstance'
    },
    controller: ReportDialogController
});
